/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const PaymentMethodInfoR = t.interface({});

// optional attributes
const PaymentMethodInfoO = t.partial({});

export const PaymentMethodInfo = t.intersection(
  [PaymentMethodInfoR, PaymentMethodInfoO],
  "PaymentMethodInfo"
);

export type PaymentMethodInfo = t.TypeOf<typeof PaymentMethodInfo>;
